import Backbone from 'backbone'
// import _ from 'underscore'

import { ClassFilterView } from './classFilter.view'
import { PokerClassCollection } from './pokerClass.collection'

import detailLink from '../template/part.detailLink.mustache'
import tpl from './pokerClass.mustache'

import { detailHandler, openPayAuto } from '../../manager/view.handler'
import { toJSONHelper } from '../../utils/'
import { gold, silver, booster } from './detail.monthly'

export var PokerClassView = Backbone.View.extend({
  tagName: 'div',
  className: 'PokerClassView',
  collection: new PokerClassCollection(),
  template: tpl,
  events: {
    'click [data-id]': openPayAuto,
    'click [data-detail-pop]': detailHandler,
  },
  initialize: function () {
    this.collection.once('sync', this.render, this)
    this.collection.fetch()
  },
  render: function () {
    var $classHead = $('<div class="poker-mall-pclass__head" />')

    var classFilterView = new ClassFilterView({
      collection: this.collection,
    })

    var items = toJSONHelper(
      this.collection.where({ ClassCategory: 'goldClassOnly' })
    )

    var classContents = this.template.render(
      {
        items: items,
        monthlyDetailGold: JSON.stringify(gold),
        monthlyDetailSilver: JSON.stringify(silver),
        monthlyDetailBooster: JSON.stringify(booster),
      },
      {
        detailLink: detailLink,
      }
    )

    $classHead.append(classFilterView.render().$el)
    this.$el.empty().append($classHead, classContents)

    return this
  },
})
